export default [
  {
    path: '*',
    meta: {
      public: true
    },
    redirect: {
      path: '/404'
    }
  },
  {
    path: '/404',
    meta: {
      public: true
    },
    name: 'NotFound',
    component: () => import(`@/pages/notfound.vue`)
  },
  {
    path: '/403',
    meta: {
      public: true
    },
    name: 'AccessDenied',
    component: () => import(`@/pages/deny.vue`)
  },
  {
    path: '/500',
    meta: {
      public: true
    },
    name: 'ServerError',
    component: () => import(`@/pages/error.vue`)
  },
  {
    path: '/login',
    meta: {
      public: true
    },
    name: 'Login',
    component: () => import(`@/pages/login.vue`)
  },
  {
    path: '/',
    meta: {},
    name: 'Root',
    redirect: {
      name: 'Dashboard'
    }
  },
  {
    path: '/dashboard',
    meta: { breadcrumb: true },
    name: 'Dashboard',
    component: () =>
      import(`@/pages/dashboard.vue`)
  },
  {
    path: '/account',
    meta: { breadcrumb: true },
    name: 'Account',
    component: () => import(`@/pages/account/index.vue`)
  },
  {
    path: '/account/add',
    meta: { breadcrumb: true },
    name: 'AddAccount',
    component: () => import(`@/pages/account/add.vue`)
  },
  {
    path: '/account/import',
    meta: { breadcrumb: true },
    name: 'ImportAccount',
    component: () => import(`@/pages/account/import.vue`)
  },
  {
    path: '/account/detail',
    meta: { breadcrumb: true },
    name: 'AccountDetail',
    component: () => import(`@/pages/account/detail.vue`)
  },
  {
    path: '/vehicle',
    meta: { breadcrumb: true },
    name: 'Vehicle',
    component: () => import(`@/pages/vehicle/index.vue`)
  },
  {
    path: '/device',
    meta: { breadcrumb: true },
    name: 'Device',
    component: () => import(`@/pages/device/index.vue`)
  },
  {
    path: '/device/import',
    meta: { breadcrumb: true },
    name: 'ImportDevice',
    component: () => import(`@/pages/device/import.vue`)
  },
  {
    path: '/device/export',
    meta: { breadcrumb: true },
    name: 'ExportDevice',
    component: () => import(`@/pages/device/export.vue`)
  },
  {
    path: '/device/return',
    meta: { breadcrumb: true },
    name: 'ReturnDevice',
    component: () => import(`@/pages/device/return.vue`)
  },
  {
    path: '/sim',
    meta: { breadcrumb: true },
    name: 'Sim',
    component: () => import(`@/pages/sim/index.vue`)
  },
  {
    path: '/sim/import',
    meta: { breadcrumb: true },
    name: 'ImportSim',
    component: () => import(`@/pages/sim/import.vue`)
  },
  {
    path: '/sim/export',
    meta: { breadcrumb: true },
    name: 'ExportSim',
    component: () => import(`@/pages/sim/export.vue`)
  },
  {
    path: '/sim/return',
    meta: { breadcrumb: true },
    name: 'ReturnSim',
    component: () => import(`@/pages/sim/return.vue`)
  },
  {
    path: '/sim/updatedata',
    meta: { breadcrumb: true },
    name: 'UpdateData',
    component: () => import(`@/pages/sim/UpdateData.vue`)
  },
  {
    path: '/sim/datareporting',
    meta: { breadcrumb: true },
    name: 'DataReporting',
    component: () => import(`@/pages/sim/DataReporting.vue`)
  },
  {
    path: '/monitor',
    meta: { breadcrumb: true },
    name: 'Monitor',
    component: () => import(`@/pages/monitor/index.vue`)
  },
  {
    path: '/notification',
    meta: { breadcrumb: true },
    name: 'Notification',
    component: () => import(`@/pages/Notification.vue`)
  },
  {
    path: '/grouprole',
    meta: { breadcrumb: true },
    name: 'GroupRole',
    component: () => import(`@/pages/GroupRole.vue`)
  },
  {
    path: '/language',
    meta: { breadcrumb: true },
    name: 'Language',
    component: () => import(`@/pages/language/Language.vue`)
  },
  {
    path: '/changelog',
    meta: { breadcrumb: true },
    name: 'Changelog',
    component: () => import(`@/pages/changelog/Changelog.vue`)
  },
];



// WEBPACK FOOTER //
// ./src/router/paths.js